import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Tabs,
  Card,
  Space,
  Input,
  Table,
  Tag,
  Tooltip,
  Empty,
  Drawer,
} from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetClientsListApi } from "./ClientsApi";
import { resetClientDetailsById } from "./ClientsSlice";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faBriefcase,
  faBuildingShield,
  faFileContract,
  faFileInvoice,
  faFolderOpen,
  faChartLine,
  faScrewdriverWrench,
  faUser,
  faUserAlt,
  faUserTie,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import ClientsList from "./Components/ClientsList";
//import PartnersClientsList from "./Components/PartnersClientsList";

function Clients() {
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState("1");
  const companyId = localStorage.getItem("CompanyId");

  useEffect(() => {
    if (pathname?.includes(`/${companyId}/partner`)) {
      setActiveTab("2");
    } else {
      setActiveTab("1");
    }
  }, [pathname]);
  const navigate = useNavigate();

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (key === "1") {
      navigate(`/${companyId}/clients`);
    } else {
      navigate(`/${companyId}/partner`);
    }
  };
  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part">
            <Row align="middle">
              <Col span={24}>
                <h4>
                  {activeTab == 1 ? (
                    <FormattedMessage id="Clients.Clients" />
                  ) : (
                    <FormattedMessage id="PartnerCLient.Partners" />
                  )}
                </h4>
                <p className="mt-5px">
                  <FormattedMessage id="Client.Info" />
                </p>
              </Col>
            </Row>
          </div>
          <Tabs activeKey={activeTab} onChange={handleTabChange}>
            <Tabs.Item
              tab={
                <span>
                  <FontAwesomeIcon icon={faUserAlt} />
                  &nbsp;
                  <FormattedMessage id="Clients.Clients" />
                </span>
              }
              key="1"
            >
              {activeTab === "1" && <ClientsList screen={"clients"} />}
            </Tabs.Item>
            <Tabs.Item
              tab={
                <span>
                  <FontAwesomeIcon icon={faUsers} />
                  &nbsp;
                  <FormattedMessage id="PartnerCLient.Partners" />
                </span>
              }
              key="2"
            >
              {activeTab === "2" && <ClientsList screen={"partnerClients"} />}
            </Tabs.Item>
          </Tabs>
        </div>
      </div>
    </>
  );
}

export default Clients;
